"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterOptionToMessageKey = void 0;
const product_table_dynamic_columns_1 = require("../../../../../hooks/product-table-dynamic-columns");
exports.filterOptionToMessageKey = {
    [product_table_dynamic_columns_1.DynamicColumnsFilterOption.Enriched]: 'ENRICHED_DATA',
    [product_table_dynamic_columns_1.DynamicColumnsFilterOption.Original]: 'BASE_DATA',
    [product_table_dynamic_columns_1.DynamicColumnsFilterOption.Measures]: 'MEASURES',
};
